import { Component } from '@angular/core';
import { TappingResult } from '@workflow/components/questionnaire/questionnaire-item/special-question/tapping-test/tapping-test.component';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-tapping-test-epilog',
	templateUrl: './tapping-test-epilog.component.html',
	styleUrls: ['./tapping-test-epilog.component.scss']
})
export class TappingTestEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<TappingResult>) {}
}
